import { render } from "./AccommodationSection.vue?vue&type=template&id=124483ad&scoped=true"
import script from "./AccommodationSection.vue?vue&type=script&lang=js"
export * from "./AccommodationSection.vue?vue&type=script&lang=js"

import "./AccommodationSection.vue?vue&type=style&index=0&id=124483ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124483ad"]])

export default __exports__